import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showManage, setShowManage] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, functional: true });

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  function acceptAll() {
    localStorage.setItem("cookie_consent", JSON.stringify({ analytics: true, functional: true, essential: true }));
    setVisible(false);
  }

  function rejectNonEssential() {
    localStorage.setItem("cookie_consent", JSON.stringify({ analytics: false, functional: false, essential: true }));
    setVisible(false);
  }

  function savePreferences() {
    localStorage.setItem("cookie_consent", JSON.stringify({ ...prefs, essential: true }));
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-overlay" data-testid="cookie-banner">
      <div className="cookie-banner">
        {!showManage ? (
          <>
            <div className="cookie-banner-body">
              <div className="cookie-icon">&#127850;</div>
              <div>
                <h3>We use cookies</h3>
                <p>
                  We use essential cookies to make this site work. With your consent, we also use analytics and functional cookies to improve your experience. See our{" "}
                  <a href="/cookie-policy" className="cookie-link">Cookie Policy</a> for details.
                </p>
              </div>
            </div>
            <div className="cookie-actions">
              <button className="cookie-btn-secondary" onClick={() => setShowManage(true)} data-testid="manage-cookies-btn">
                Manage Preferences
              </button>
              <button className="cookie-btn-secondary" onClick={rejectNonEssential} data-testid="reject-cookies-btn">
                Reject Non-Essential
              </button>
              <button className="cookie-btn-primary" onClick={acceptAll} data-testid="accept-cookies-btn">
                Accept All Cookies
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-manage">
              <h3>Manage Cookie Preferences</h3>
              <div className="cookie-toggle-row">
                <div>
                  <strong>Essential Cookies</strong>
                  <p>Required for the website to function. Cannot be disabled.</p>
                </div>
                <span className="cookie-always-on">Always On</span>
              </div>
              <div className="cookie-toggle-row">
                <div>
                  <strong>Analytics Cookies</strong>
                  <p>Help us understand how visitors use our site (Google Analytics).</p>
                </div>
                <label className="cookie-switch">
                  <input type="checkbox" checked={prefs.analytics} onChange={e => setPrefs(p => ({ ...p, analytics: e.target.checked }))} />
                  <span className="cookie-slider" />
                </label>
              </div>
              <div className="cookie-toggle-row">
                <div>
                  <strong>Functional Cookies</strong>
                  <p>Enable enhanced features like remembering your preferences.</p>
                </div>
                <label className="cookie-switch">
                  <input type="checkbox" checked={prefs.functional} onChange={e => setPrefs(p => ({ ...p, functional: e.target.checked }))} />
                  <span className="cookie-slider" />
                </label>
              </div>
            </div>
            <div className="cookie-actions">
              <button className="cookie-btn-secondary" onClick={() => setShowManage(false)} data-testid="back-cookies-btn">
                Back
              </button>
              <button className="cookie-btn-primary" onClick={savePreferences} data-testid="save-cookies-btn">
                Save Preferences
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
